<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <!--<Button type="primary" size="small" @click="addVehicleInfoModal=true">添加车辆信息</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="onFilterClick" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-vehicle-info-modal v-model="addVehicleInfoModal" @on-success="onSuccess"></add-vehicle-info-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <business-note-list-modal v-model="businessNoteListModal" :initValue="businessNoteListId"
                              @on-success="onModifySuccess"></business-note-list-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
    <assemble-positioning-device-modal v-model="assemblePositioningDeviceModal" :initValue="assembleVehicleInfoId"
                                       @on-success="onModifySuccess"></assemble-positioning-device-modal>
  </div>
</template>

<script>
import AddVehicleInfoModal from '@/view/crm/components/add-vehicle-info-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/crm/components/vehicle-picture-modal'
import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import BusinessNoteListModal from '@/view/crm/components/business-note-list-modal'
import AssemblePositioningDeviceModal from '@/view/im/components/assemble-positioning-device-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'myvehicleinfos',
  components: {
    VehiclePictureModal,
    AddVehicleInfoModal,
    VehicleInfoDetailModal,
    BusinessNoteDetailModal,
    BusinessNoteListModal,
    AssemblePositioningDeviceModal
  },
  data () {
    return {

      gdcdgovVehicleStateFilter: null,
      hasBindServiceDevicesFilter:null,

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 配置设备
      assemblePositioningDeviceModal: false,
      assembleVehicleInfoId: null,

      // 添加收入项
      addVehicleInfoModal: false,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleInfoId: null
      },

      // 业务笔记列表
      businessNoteListModal: false,
      businessNoteListId: null,

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          width: 150,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                backgroundColor: calRegistrationColor(params.row.registrationColor),
                color: calRegistrationTextColor(params.row.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '定位服务',
          resizable: true,
          key: 'hasBindServiceDevices',
          ellipsis: 'true',
          width: 140,
          filters: this.HasBindServiceDevicesType,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.hasBindServiceDevicesFilter = []
              val.forEach(item => {
                this.hasBindServiceDevicesFilter.push(genQueryParam('hasBindServiceDevices', 'EQ', item))
              })
            } else {
              this.hasBindServiceDevicesFilter = null
            }
          },
          render: function (h, params) {
            const hasBindServiceDevices = params.row.hasBindServiceDevices
            if (hasBindServiceDevices) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    size: 'small',
                    color: 'green'
                  }
                }, '已安装设备')
              ])
            } else {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    size: 'small',
                    color: 'red'
                  }
                }, '无定位设备')
              ])
            }
          }
        },
        {
          title: '广东省厅数据状态',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          filters: [
            { label: '无资料', value: 0 },
            { label: '正常', value: 1 },
            { label: '运营商不符', value: 2 },
            { label: '非营运', value: 3 },
            { label: '定位时间不符', value: 4 },
            { label: '非运政车辆', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.gdcdgovVehicleStateFilter = []
              val.forEach(item => {
                this.gdcdgovVehicleStateFilter.push(genQueryParam('gdcdgovVehicleState', 'EQ', item))
              })
            } else {
              this.gdcdgovVehicleStateFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let gdcdgovVehicleState = params.row.gdcdgovVehicleState
            if (gdcdgovVehicleState === 0) {
              return h('div', '无资料')
            } else if (gdcdgovVehicleState === 1) {
              return h('div', '正常')
            } else if (gdcdgovVehicleState === 2) {
              return h('div', '运营商不符')
            } else if (gdcdgovVehicleState === 3) {
              return h('div', '非营运')
            } else if (gdcdgovVehicleState === 4) {
              return h('div', '定位时间不符')
            } else if (gdcdgovVehicleState === 5) {
              return h('div', '非运政车辆')
            }
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 220,
          render: (h, params) => {
            let display = []
            if (params.row.clientInfo) {
              display.push(h('div', '客户信息:' + params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '客户信息:无'))
            }
            if (params.row.vehicleInfoGroup) {
              display.push(h('div', '分组:' + params.row.vehicleInfoGroup.name))
            } else {
              display.push(h('div', '分组:无'))
            }
            return h('div', display)
          }
        },
        {
          title: '车架号',
          resizable: true,
          key: 'vin',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '定位设备',
          resizable: true,
          ellipsis: 'true',
          width: 350,
          render: (h, params) => {
            let positioningDeviceInfos = params.row.positioningDeviceInfos
            if (positioningDeviceInfos && positioningDeviceInfos.length > 0) {
              let d = []
              positioningDeviceInfos.forEach(item => {``
                let display = ''
                let displaySims = null
                display = display + item.positioningDeviceModel.name + ':'
                if (item.simInfos && item.simInfos.length > 0) {
                  displaySims = ''
                  item.simInfos.forEach(item => {
                    displaySims = displaySims + item.simNum
                  })
                  displaySims = displaySims.substr(0, displaySims.length - 1)
                  display = display + item.terminalNum + '[SIM卡号:' + displaySims + ']'
                } else {
                  display = display + item.terminalNum
                }
                display = display + '(到费期:' + new Date(item.serviceDatetime).Format('yyyy年MM月dd日') + ')'
                d.push(h('div', display))
              })
              // display = display.substr(0, display.length - 1)
              return h('div', d)
            } else {
              return h('div', '未安装')
            }
          }
        },
        {
          title: '历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'historyRecord',
          width: 200
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 200,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 300,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.id
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.assembleVehicleInfoId = params.row.id
                    this.assemblePositioningDeviceModal = true
                  }
                }
              }, '配置设备'),
              h('Button', {
                props: {
                  type: params.row.businessNoteCount >0 ? 'success' : 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // this.businessNoteInfo.vehicleInfoId = params.row.id
                    // this.businessNoteInfo.id = params.row.businessNoteId
                    // this.businessNoteDetailModal = true

                    this.businessNoteListModal = true
                    this.businessNoteListId = params.row.id

                  }
                }
              }, '业务笔记'),
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'VehicleInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo1 = this.gdcdgovVehicleStateFilter
      }
      if(this.hasBindServiceDevicesFilter){
        qo2 = this.hasBindServiceDevicesFilter
      }

      store.dispatch('VehicleInfoServ_GetMyPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_VehicleInfo_GetMyPageResult) {
        return store.getters.get_VehicleInfo_GetMyPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_VehicleInfo_GetMyPageResult) {
        return store.getters.get_VehicleInfo_GetMyPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_VehicleInfo_GetMyPageResult) {
        return store.getters.get_VehicleInfo_GetMyPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
